// import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// export default function CookieConsentBanner() {
//   const [show, setShow] = useState(false);
//   const [consent, setConsent] = useState({ essential: true, analytics: false, marketing: false });

//   // Show banner if no consent stored
//   useEffect(() => {
//     const stored = localStorage.getItem("cookie_consent");
//     if (!stored) setShow(true);
//     else setConsent(JSON.parse(stored));
//   }, []);

//   const handleConsent = (acceptAll) => {
//     const newConsent = {
//       essential: true,
//       analytics: acceptAll,
//       marketing: acceptAll,
//       date: Date.now(),
//     };
//     localStorage.setItem("cookie_consent", JSON.stringify(newConsent));
//     setConsent(newConsent);
//     setShow(false);
//   };

//   if (!show) return null;

//   return (
//     <div
//       className="position-fixed bottom-0 start-0 m-3"
//       style={{ zIndex: 1050, maxWidth: "350px" }}
//     >
//       <div className="card shadow-sm border">
//         <div className="card-body p-3">
//           <h6 className="card-title">We use cookies</h6>
//           <p className="card-text small">
//             We use essential cookies to make the site work. With your permission, we also use analytics
//             and marketing cookies to improve the site and show relevant content.
//           </p>
//           <div className="d-flex justify-content-end gap-2">
//             <button className="btn btn-outline-secondary btn-sm" onClick={() => handleConsent(false)}>
//               Reject
//             </button>
//        <button
//   className="btn btn-sm"
//   style={{ backgroundColor: "black", color: "white" }}
//   onClick={() => handleConsent(true)}
// >
//   Accept all
// </button>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function CookieConsentBanner() {
  const [show, setShow] = useState(false);
  const [consent, setConsent] = useState({ essential: true, analytics: false, marketing: false });

  useEffect(() => {
    const stored = localStorage.getItem("cookie_consent");
    if (!stored) setShow(true);
    else setConsent(JSON.parse(stored));
  }, []);

  const handleConsent = (acceptAll) => {
    const newConsent = {
      essential: true,
      analytics: acceptAll,
      marketing: acceptAll,
      date: Date.now(),
    };
    localStorage.setItem("cookie_consent", JSON.stringify(newConsent));
    setConsent(newConsent);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="position-fixed bottom-0 start-0 m-3"
      style={{ zIndex: 1050, maxWidth: "360px", animation: "slideUp 0.5s ease" }}
    >
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-body p-4">
          <h6 className="card-title fw-bold mb-2">🍪 We use cookies</h6>
          <p className="card-text small text-muted mb-3">
            We use essential cookies to make the site work. With your permission, we also use analytics
            and marketing cookies to improve the site and show relevant content.
          </p>
          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-outline-secondary btn-sm fw-semibold"
              onClick={() => handleConsent(false)}
              style={{ minWidth: "80px" }}
            >
              Reject
            </button>
            <button
              className="btn btn-dark btn-sm fw-semibold"
              onClick={() => handleConsent(true)}
              style={{ minWidth: "90px" }}
            >
              Accept all
            </button>
          </div>
        </div>
      </div>

      {/* Slide-up animation */}
      <style>{`
        @keyframes slideUp {
          0% { transform: translateY(100%); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }
        .btn-dark:hover {
          background-color: #222;
          color: #fff;
        }
        .btn-outline-danger:hover {
          background-color: #f8d7da;
          border-color: #f5c2c7;
        }
      `}</style>
    </div>
  );
}
